import styled, { css } from 'styled-components';
import { IStyledWrapperProps } from './types';

export const Wrapper = styled.div<IStyledWrapperProps>`
  ${({ $isSuccess, theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
    text-align: center;
    color: ${theme.colors[$isSuccess ? 'success' : 'secondary']};
    font-size: ${theme.fonts.sizes.subtitle};
    margin: auto;
    max-width: 35rem;
  `}
`;
